(function () {
  function getProductData(productId) {
    var store = (window._themeProducts || {});
    return store[productId] || store[String(productId)] || store[Number(productId)] || null;
  }

  function getSelectedVariantId(sectionEl) {
    if (!sectionEl) return null;
    // Prefer the last occurrence in the section (actual form input), not the fallback one
    var inputs = sectionEl.querySelectorAll('input[name="id"]');
    if (!inputs || !inputs.length) return null;
    var input = inputs[inputs.length - 1];
    if (!input) return null;
    var val = input.value || input.getAttribute('value');
    var id = parseInt(val, 10);
    return isNaN(id) ? null : id;
  }

  function updateBadgeForContainer(container) {
    try {
      var productId = container.getAttribute('data-product-id');
      var sectionId = container.getAttribute('data-section');
      var sectionEl = (sectionId && document.querySelector('[data-section-id="' + sectionId + '"]')) || container.closest('[data-section-id]') || container.closest('.sf-prod__info') || document;
      if (!productId || !sectionEl) return;

      var savedEl = sectionEl.querySelector('[data-saved-price]');
      var badgeEl = sectionEl.querySelector('.f-price__badge-sale');
      if (!savedEl) return;

      var product = getProductData(productId);
      if (!product || !Array.isArray(product.variants)) return;

      var variantId = getSelectedVariantId(sectionEl);
      if (!variantId) return;

      var variant = product.variants.find(function (v) { return v && v.id === variantId; });
      if (!variant) return;

      var compare = variant.compare_at_price || 0;
      var price = variant.price || 0;
      if (compare > price) {
        var pct = Math.floor(((compare - price) * 100) / compare);
        savedEl.textContent = pct + '%';
      } else {
        // Not on sale
        savedEl.textContent = '';
      }
    } catch (e) {
      (console && console.debug) && console.debug('variant-badge-update error:', e);
    }
  }

  function setup(container) {
    var handler = function () {
      // Defer to let variant-picker update the input value first
      setTimeout(function () { updateBadgeForContainer(container); }, 0);
    };
    container.addEventListener('change', handler);
    // Initial sync
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(handler);
    } else {
      setTimeout(handler, 0);
    }
  }

  function init() {
    document.querySelectorAll('[data-variant-picker]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
